import { Container, Heading as MarketistHeading, Text, Link } from '@doist/marketist'
import { formatPubDate } from 'services/dateFormatter'
import * as React from 'react'
import css from './Heading.module.css'

export type HeadingProps = {
    data: Metadata
}

export function Heading({ data }: HeadingProps): JSX.Element {
    return (
        <Container className={css.heading}>
            <Text size="minor-xs">{formatPubDate(data.pubDate)}</Text>
            <MarketistHeading className={css.title} level="1" size="major-2xl">
                {data.title}
            </MarketistHeading>
            <Text className={css.description}>{data.description}</Text>
            <Text>
                By{' '}
                {data.authors.map((author, index) => (
                    <React.Fragment key={crypto.randomUUID()}>
                        {author.link ? (
                            <Link href={author.link} target="_blank">
                                {author.name}
                            </Link>
                        ) : (
                            author.name
                        )}
                        {index < data.authors.length - 1 && ', '}
                    </React.Fragment>
                ))}
            </Text>
        </Container>
    )
}
